import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_MODULOS,
  ALL_MODULOS,
  LOADING_ALL_MODULOS,
} from './ModulosReducer';
import {
  deleteModulosService,
  allModulosService,
  oneModulosService,
  saveModulosService,
} from './ModulosService';

export const allModulosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_MODULOS, payload: true });
    const res = await allModulosService(params);
    dispatch({ type: ALL_MODULOS, payload: res.data });
    dispatch({ type: LOADING_ALL_MODULOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_MODULOS, payload: false });
    tryCatchHelper(e);
  }
};

export const saveModulosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveModulosService(id, data);
    notify(res.data.message);
    await allModulosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoModulosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_MODULOS, payload: data });
};

export const oneModulosAction = async (dispatch, id) => {
  try {
    const res = await oneModulosService(id);
    await setActivoModulosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteModulosAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteModulosService(id);
    await setActivoModulosAction(dispatch, null);
    notify(res.data.message);
    await allModulosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
